import React from 'react';
import {BannerRenderProps, IBannerDefinition} from './banner-definition.interface';
import {BannerContentComponent} from '../../../../components/cms-banner/banner-content/banner-content.component';
import {CmsBannerId} from '../cm-banner-id/cms-banner-id';


export class BannerDefinition implements IBannerDefinition {
  constructor(public _html: string, private _bannerId: CmsBannerId) {
  }

  render(props: BannerRenderProps): React.ReactNode {
    return (<BannerContentComponent html={this._html} bannerId={this._bannerId} />);
  }
}
